import React from "react";
import { useApp } from "../../../contexts";
import { useState, useEffect } from "react";
import { SearchIcon } from "../../../components/Icons/SearchIcon";
import { FilterIcon } from "../../../components/Icons/FilterIcon";
import { useWindowSize } from "../../../hook/useWindowSize";
import Sort from "./Sort";
import { FilterGradienIcon } from "../../../components/Icons/FilterGradienIcon";
import useDebounce from "../../../hook/useDebounce";

export const RowFilter = (props) => {
  const { T } = useApp();
  const size = useWindowSize();
  const { handleShowFilter, showFilter, setFilterData, filterData, type } =
    props;
  const [filterText, $filterText] = useState("");
  const isMobile = size.width < 1024 ? true : false;
  const debouneFilterText = useDebounce(filterText, 500);

  useEffect(() => {
    setFilterData({
      name: debouneFilterText,
    });
  }, [debouneFilterText]);

  const handleFilterData = (val) => {
    setFilterData({
      sort: val.sort,
    });
  };
  return !isMobile ? (
    <div className="flex justify-start items-center w-full gap-[15px] lg:mt-[5px] xls:mt-[15px]">
      <div
        className={`flex justify-center items-center px-[14px] py-[10px] bg-white gap-[8px] rounded-[10px] cursor-pointer`}
        onClick={() => handleShowFilter()}
      >
        {!showFilter ? (
          <span>
            <FilterIcon />
          </span>
        ) : (
          <FilterGradienIcon />
        )}
        <span className={`text-sm text-black`}>{T("Filter")}</span>
      </div>
      <div className="flex-1 lg:mx-[15px] relative">
        {(type == "character" || type == "nft_prime") && (
          <>
            <SearchIcon className="absolute left-[16px] top-[12px]" />
            <input
              type="text"
              className="h-[40px] outline-none pl-[50px] w-full max-w-full px-5 py-3 bg-white rounded-[10px] text-black "
              placeholder={type === "nft_prime" ? T("Search Art Prime Name") : T("Type anything to search")}
              onChange={(e) => $filterText(e.target.value)}
            />
          </>
        )}
      </div>
      <Sort
        filterData={filterData}
        type={type}
        setFilterData={(val) => handleFilterData(val)}
      />
    </div>
  ) : (
    <></>
  );
};
